export const PUBLIC_LEGAL_URLS = Object.freeze({
  privacyPolicy: '/privacy-policy',
  termsOfService: '/terms-of-service',
  legalNotice: '/gfcore/index.html?page=legal&doc=legal-notice',
  cookies: '/gfcore/index.html?page=legal&doc=cookies',
});

export const LEGAL_COMPANY_NAME = 'Devlore';
export const LEGAL_HOSTING_PROVIDER = 'IONOS';
export const LEGAL_REGISTERED_ADDRESS = 'Franklin Roosevelt - 25 rue de Ponthieu, 75008 Paris';
export const LEGAL_SIRET = '00000';
